import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractEntityDataProvider } from '@entity-framework/entity-record/entity-data-provider/abstract-entity.data-provider';
import { LoggingService } from '@logging/logging.service';
import { UpdatePasswordFormData } from './update-password.model';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class UpdatePasswordDataProvider extends AbstractEntityDataProvider<UpdatePasswordFormData> {
  /** Satisfies {@link AbstractEntityDataProvider}; reset uses {@link updatePassword$} URL instead of {@link getBaseEndpoint}. */
  protected override apiRoot = environment.apiPaths.root;

  constructor(
    protected override httpClient: HttpClient,
    protected override logger: LoggingService
  ) {
    super(httpClient, logger);
  }

  updatePassword$(
    request: UpdatePasswordFormData,
    linkTypeId: string,
    linkId: string
  ): Observable<{ errorMessages: { message: string }[] }> {
    const enc = encodeURIComponent;
    const url = `${environment.apiPaths.root}User/ResetPassword/${enc(linkTypeId)}/${enc(linkId)}`;
    return this.httpClient.post<{ errorMessages: { message: string }[] }>(url, request);
  }
}
